<template>
  <div class="container-modal-cdb" v-if="showModal">
    <div class="section-modal-cdb">
      <div class="header-modal-cdb">
        <h2 class="title-modal-cdb">RESPONSÁVEL PELO CIRCO</h2>
      </div>
      <div class="info-modal-cdb">
        <input type="text" class="form-input-cdb" v-model="formContact.name" placeholder="Digite seu nome">
        <input type="text" class="form-input-cdb" v-model="formContact.email" placeholder="Digite seu e-mail">
        <input type="text" class="form-input-cdb" v-model="formContact.subject" placeholder="Assunto">
        <input type="text" class="form-input-cdb" v-model="formContact.phone" placeholder="Celular">
        <textarea class="form-input-cdb" v-model="formContact.content" />
      </div>
      <div class="confirm-contact-cdb">
        <button class="confirm-info-cdb" @click="sendFaleConosco">OK</button>
        <button class="close-info-cdb" @click="showModal = false">
          <span class="material-symbols-outlined close-icon-small">close</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { sendService} from "@/components/common/services/send"

export default {
  name: 'ModalContactCdb',
  components: {},
  props: [],
  data () {
    return {
      showModal: false,
      formContact: {
        name: '',
        email: '',
        subject: '',
        phone: '',
        content: ''
      }
    }
  },
  mounted () {
    this.$root.$on('open-modal-contact', payload => {
      this.showModal = payload
    })
  },
  computed: {

  },
  methods: {
    sendFaleConosco() {
      if(this.formContact.name=='' || this.formContact.email==''|| this.formContact.phone=='' || this.formContact.subject==''|| this.formContact.content=='' ){
            this.$swal({
                  title: "É necessário informar todos os dados",
                  type: "error",
                  showConfirmButton: true,
                  timer: 4000,
                })
      }else{

      sendService.sendFaleConosco(this.formContact).then(
            response => {
              if(response.result){
                this.formContact={
                        name: '',
                        email: '',
                        subject: '',
                        phone: '',
                        content: ''
                  };
                this.$swal({
                  title: "Sua solicitação foi enviada com sucesso entraremos em contato o mais breve possível.",
                  type: "success",
                  showConfirmButton: false,
                  timer: 4000,
                })
              }else{
                 this.$swal({
                  title: "Ocorreu um erro, tente novamente",
                  type: "error",
                  showConfirmButton: false,
                  timer: 4000,
                })
              }
              
            },
            error => {
                this.$swal({
                  title: "Ocorreu um erro, tente novamente",
                  type: "error",
                  showConfirmButton: false,
                  timer: 4000,
                })
             
            }
          );
        } 
     }
  }
}
</script>

<style lang="scss">
.container-modal-cdb {
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #42424240;
  .section-modal-cdb {
    position: relative;
    z-index: 10;
    border-top: 10px solid #BF3D26;
    width: 30%;
    height: 50%;
    background: #FAF5E4;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-modal-cdb {
      width: 100%;
      height: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
      .title-modal-cdb {
        font-size: 1.8em;
      }
    }
    .info-modal-cdb {
      width: 100%;
      height: 70%;
      padding: 10px 0 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .form-input-cdb {
        width: 65%;
        height: 13%;
        padding-left: 5px !important;
        border: 1px solid #BF3D26;
        border-radius: 8px;
        outline: none;
        color: #424242;
      }
      .form-input-cdb:last-child {
        height: 70px;
        padding: 5px !important;
        resize: none;
      }
    }
    .confirm-contact-cdb {
      width: 100%;
      height: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
      .confirm-info-cdb {
        background: #BF3D26;
        color: #FFFFFF;
        border: none;
        height: 60%;
        width: 15%;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1.1em;
      }
      .close-info-cdb {
        position: absolute;
        top: 3px;
        right: 3px;
        border: none;
        background: #BF3D26;
        color: #FFFFFF;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .close-icon-small {
          font-size: 20px;
        }
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .section-modal-cdb {
    width: 95% !important;
    height: 60% !important;
    .info-modal-cdb {
      .form-input-cdb {
        width: 90% !important;
      }
    }
    .confirm-contact-cdb {
      .confirm-info-cdb {
        width: 25% !important;
        height: 70% !important;
      }
    }
  }
}
</style>